/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.page.modals.controllers', [])

.controller('PosCreatePagesFormsPageModalsController', ['$scope', '$uibModalInstance', 'page', 'allow', 'items', function($scope, $uibModalInstance, page, allow, items) {

    $scope.posCreatePagesFormsPageModals = {

      model: {
        allow: allow,
        page: page,
        items: items
      },

      init: function() {},
      
      done: function () {
        if (this.model.allow) {
          $uibModalInstance.close(true);
        }else{
          this.cancel();
        }
      },
      
      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },
      
      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.posCreatePagesFormsPageModals.init();

}]);